import { makeAutoObservable } from "mobx";

import { AdminAccessStore } from "./AdminAccessStore";
import { AuthStore } from "./AuthStore";
import { BranchStore } from "./BranchStore";
import { BrandStore } from "./BrandStore";
import { CurrencyFilterStore } from "./CurrencyFilterStore";
import { GroupStore } from "./GroupStore";
import { ImpersonationStore } from "./ImpersonationStore";
import { MenuStore } from "./MenuStore";
import { RestaurantAccessStore } from "./RestaurantAccessStore";

export class RootStore {
  authStore: AuthStore;
  impersonation: ImpersonationStore;
  groupStore: GroupStore;
  branchStore: BranchStore;
  brandStore: BrandStore;
  menuStore: MenuStore;
  restaurantAccessStore: RestaurantAccessStore;
  adminAccessStore: AdminAccessStore;
  currencyFilter: CurrencyFilterStore;

  constructor() {
    this.adminAccessStore = new AdminAccessStore();
    this.authStore = new AuthStore();
    this.impersonation = new ImpersonationStore();
    this.groupStore = new GroupStore();
    this.brandStore = new BrandStore();
    this.branchStore = new BranchStore();
    this.menuStore = new MenuStore();
    this.restaurantAccessStore = new RestaurantAccessStore();
    this.currencyFilter = new CurrencyFilterStore();
    makeAutoObservable(this);
  }

  clearWizard() {
    this.groupStore.clear();
    this.brandStore.clearStore();
    this.branchStore.clearStore();
  }
}

export const rootStore = new RootStore();
